import { render, staticRenderFns } from "./CfsReceiving.vue?vue&type=template&id=67481a1d&scoped=true&"
import script from "./CfsReceiving.vue?vue&type=script&lang=js&"
export * from "./CfsReceiving.vue?vue&type=script&lang=js&"
import style0 from "./CfsReceiving.vue?vue&type=style&index=0&id=67481a1d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67481a1d",
  null
  
)

export default component.exports